import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["type"];
import { useTheme } from 'foundations-theming/utils';
import { fwcBorderWidth } from 'foundations-theming/utils/fwc';
import { Alert } from '../Alert';
import { FireAlarmProvider } from './FireAlarmProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const FireAlarm = _ref => {
  let {
      type = 'warning'
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const systemPrefixedType = `system-${type}`;
  const theme = useTheme();
  const alertStyleOverrides = {
    borderWidth: theme.borderWidth[fwcBorderWidth('fwc-alert-100')]
  };
  return /*#__PURE__*/_jsx(FireAlarmProvider, {
    alertStyleOverrides: alertStyleOverrides,
    children: /*#__PURE__*/_jsx(Alert, Object.assign({
      type: systemPrefixedType
    }, props))
  });
};
FireAlarm.displayName = 'FireAlarm';